module.exports = __webpack_public_path__ + "8344235d92c6e721481e414da83a6908.pdf";